import requestInstance from "./requestInstance";

export const getResources = (searchQuery, page, perPage) => {
  return requestInstance.get(
    `/api/v1/resources/get?searchQuery=${searchQuery}&page=${page}&perPage=${perPage}`
  );
};
